import { Component, OnDestroy, OnInit } from '@angular/core';
import { AccountTypes } from '@interfaces/models/account-types';
import { Store } from '@ngrx/store';
import { InheritanceIneligibleContent } from '@src/app/shared/services/content/content-jsons/inheritance-ineligible-content';
import { take } from 'rxjs';

import { getConfigClientFromRTE } from '../../../../core/config/config-client';
import {
  ClearStateAndStorage,
  closeSpinner,
  TrackCallToAction,
  TrackProcessSideStep,
} from '../../../../core/store';
import * as fromRootStore from '../../../../core/store';
import { selectRouterState } from '../../../../core/store/selectors/router/common/router.selectors';
import {
  clientStatusSelection,
  selectAccountType,
} from '../../../../core/store/selectors/triage/triage.selectors';
import { PageComponent } from '../../../../shared/components/page/page.component';
import { ContentPageId } from '../../../../shared/models/content-page-ids';
import { LoggerCodes, LoggerService } from '../../../../shared/modules/logger/logger';
import { WindowRef } from '../../../../shared/modules/window-ref/window-ref';

@Component({
  selector: 'app-inheritance-ineligible',
  templateUrl: './inheritance-ineligible.component.html',
  styleUrls: ['./inheritance-ineligible.component.scss'],
})
export class InheritanceIneligibleComponent extends PageComponent implements OnInit, OnDestroy {
  config: any;
  content = InheritanceIneligibleContent;
  accountType: AccountTypes;
  isClient: string;

  constructor(
    globalStore: Store<fromRootStore.State>,
    protected loggerService: LoggerService,
    private windowRef: WindowRef,
  ) {
    super(ContentPageId.ineligible, globalStore);
    loggerService.info(
      { eventId: 'page-load', message: 'InheritanceIneligible.Load' },
      LoggerCodes.GENERAL_SUCCESS,
    );
  }

  ngOnInit() {
    super.ngOnInit();

    this.subs.add(
      this.globalStore
        .select(selectAccountType)
        .pipe(take(1))
        .subscribe((accountType) => {
          this.accountType = accountType;
        }),
    );

    this.subs.add(
      this.globalStore
        .select(clientStatusSelection)
        .pipe(take(1))
        .subscribe((isClient) => {
          this.isClient = isClient === 'YES' ? 'CLIENT' : 'GUEST';
        }),
    );

    this.subs.add(
      this.globalStore.select(selectRouterState).subscribe((routerData) => {
        this.adobeIneligible(routerData.queryParams);
      }),
    );

    this.config = getConfigClientFromRTE();
    this.globalStore.dispatch(closeSpinner());
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.globalStore.dispatch(ClearStateAndStorage());
    }, 1000);
  }

  getAdditionalInfoByAccountType() {
    return this.accountType === AccountTypes.IRA ? this.content.IRA : this.content.NONRETIREMENT;
  }

  getContactUsByAccountType() {
    switch (true) {
      case this.accountType === AccountTypes.OTHER:
        return this.content.contactUsOther;
      case this.accountType === AccountTypes.JOINT:
        return this.isClient === 'CLIENT'
          ? this.content.contactUsJointAccount
          : this.content.contactUs;
      default:
        return this.content.contactUs;
    }
  }

  learnMore() {
    this.adobeTrackButtonClick();
    this.windowRef.nativeWindow.location.href = this.content.url;
  }

  adobeTrackButtonClick() {
    const data = {
      location: `coo-inheritance-ineligible`,
      ctaName: `coo-inheritance`,
      ctaType: 'button',
    };
    this.globalStore.dispatch(TrackCallToAction(data));
  }

  adobeIneligible(params) {
    const pvrError = !!params.pvrError;
    const ineligible = pvrError ? `coo_pvr_error` : `coo-inheritance-ineligible`;

    this.globalStore.dispatch(
      TrackProcessSideStep({
        processType: `coo-inheritance-flow`,
        processSideStep: `${ineligible}`,
      }),
    );

    if (pvrError) {
      this.loggerService.error({ message: 'PVR error' }, params.pvrError);
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
